import ParkPassAPI from "../parkpassAxiosConfig";

export const getAdminLogs = async (params = {}) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get("/v1/logs/logs/page/", {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogsByUser = async (userId, params = {}) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get(`/v1/logs/logs/user/${userId}`, {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogsByDateRange = async (fromDate, toDate, params = {}) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get(
      `/v1/logs/logs/${fromDate}/${toDate}`,
      { params: { page, pageSize } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogsByAction = async (action, params = {}) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get(
      `/v1/logs/logs/action/action/${action}`,
      { params: { page, pageSize } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLogsByUserAndDateRange = async (
  userId,
  fromDate,
  toDate,
  params = {}
) => {
  try {
    const { page = 1, pageSize = 25 } = params;
    const response = await ParkPassAPI.get(
      `/v1/logs/logs/user/${userId}/${fromDate}/${toDate}`,
      { params: { page, pageSize } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
